
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import axios from '../Axiosinstance';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Container,
    Button,
    MenuItem,
    Select,
    TextField, InputAdornment, IconButton,
    Box,
    TablePagination, Card, CardContent,
    Paper,
    Dialog, DialogTitle, FormControl, InputLabel, Typography, Grid, DialogContentText
} from '@mui/material';
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../common'
import dayjs from 'dayjs';
import { format, parseISO } from 'date-fns';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
// import { Button, Modal, Spinner } from 'react-bootstrap';

import { toast, ToastContainer } from 'react-toastify';



const ViewDetailsModal = ({ editForm, onAction }) => {



    const [isFocused, setIsFocused] = useState(false);
    const statusOptions = ['Single', 'Married', 'Widowed', 'Divorced'];

    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const [editFormData, setEditFormData] = useState(editForm);
    const [selectedFile, setSelectedFile] = useState(null);
    const [nricdoc, setNricdoc] = useState(null);
    const [educationdoc, setEducationaldoc] = useState(null);
    const [passportdoc, setPassportdoc] = useState(null);
    const [initialDate, setInitialDate] = useState(editForm.enrolledDate);
    const [initialModulus, setInitialModulus] = useState(editForm.startModulus)
    const [batches, setBatches] = useState([]);
    const [selectedBatchesData, setSelectedBatchesData] = useState(editForm.batch);
    const [errors, setErrors] = useState({});
    const moduleCount = selectedBatchesData?.moduleDetails?.length || 0;
    const [intakeId, setIntakeId] = useState('');
    const [intakeOptions, setIntakeOptions] = useState([]);
    const [showPassword, setShowPassword] = useState(false);


    const [uploadedPreviews, setUploadedPreviews] = useState({
        profileUrl: editForm.profileUrl || '',
        nricdoc: editForm.nricdoc || '', // Correct key names
        educationdoc: editForm.educationdoc || '',
        passportdoc: editForm.passportdoc || '',
    });
    // const [uploadedImageUrl, setUploadedImageUrl] = useState('');

    // const [formData, setFormData] = useState({
    //     fullname: '',
    // });

    const CLOUDINARY_URL = baseURL;
    const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;
    const formatDateForDisplay = (dateString) => {
        if (!dateString) return '';
        try {
            const parsedDate = parseISO(dateString); // parse yyyy-MM-dd
            return format(parsedDate, 'dd-MM-yyyy');
        } catch (error) {
            return dateString;
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === "passportExpiryDate") {
            const inputValue = value;
            // Convert dd-MM-yyyy to yyyy-MM-dd before saving
            const [day, month, year] = inputValue.split("-");
            const formattedValue = `${year}-${month}-${day}`;

            setEditFormData((prevData) => ({
                ...prevData,
                [name]: formattedValue,
            }));
        }
        if (name === "course") {
            // Find the selected batch details
            const selectedBatch = batches.find((batch) => batch.course === value);
            setSelectedBatchesData(selectedBatch);
            fetchintake(selectedBatch.id);
            // console.log("selectedBatch", selectedBatch);
            const currentDate = new Date();
            // const newModulus = handleDateChangeForCourse(selectedBatch, currentDate);
            // Update editFormData with course, batchId, and startModulus

            const moduleCount = selectedBatch.moduleDetails?.length || 0;
            const newScheduleDate = Array.from({ length: moduleCount }, () => ({
                startModulus: '',
                startDate: '',
                endDate: '',
            }));

            setEditFormData((prevData) => ({
                ...prevData,
                course: value, // Selected course name
                batchId: selectedBatch?.id || null, // Selected batchId
                // startModulus: newModulus || null, // Selected currentModule
                batch: selectedBatch || null,
                scheduleDate: newScheduleDate,
            }));
        } else {
            // For other fields, update the state normally
            setEditFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const handleNricEmailChange = async (e) => {
        const { name, value } = e.target;

        // Apply formatting only for NRIC
        const formattedValue = name === "nric" ? value.toUpperCase().trim() : value.trim();

        // Update form state
        setEditFormData((prev) => ({ ...prev, [name]: formattedValue }));

        // NRIC-specific validation
        if (name === "nric") {
            const nricRegex = /^[STFGM]\d{7}[A-Z]$/i;
            if (!nricRegex.test(formattedValue)) {
                setErrors((prev) => ({ ...prev, nric: "Invalid NRIC format (e.g., S1234567A)" }));
                return;
            } else {
                setErrors((prev) => ({ ...prev, nric: "" }));
            }
        }

        // API check
        if (formattedValue !== "") {
            try {
                const response = await axios.get(`/registrationadvances/exists?${name}=${formattedValue}`);

                if (response.data) {
                    setErrors((prev) => ({ ...prev, [name]: `${name.toUpperCase()} already exists!` }));
                } else {
                    setErrors((prev) => ({ ...prev, [name]: "" }));
                }
            } catch (error) {
                console.error(`Error checking ${name}:`, error);
                setErrors((prev) => ({ ...prev, [name]: `Error checking ${name}. Try again!` }));
            }
        }
    };



    // console.log("ff", editFormData);

    const handleSaveEdit = async (e) => {
        e.preventDefault();

        try {
            // Validate required fields
            const requiredFields = ['name', 'email', 'phone', 'nric', 'passport', 'passportExpiryDate', 'enrolledDate', 'course', 'religion', 'citizenship', 'address',];
            const emptyFields = requiredFields.filter(
                (field) => !editFormData[field] || editFormData[field].trim() === ''
            );

            if (emptyFields.length > 0) {
                toast.error(`The following fields are required: ${emptyFields.join(', ')}`);
                return;
            }

            const highestCount = editFormData.institutionDetails.filter(inst => inst.highest).length;
            if (highestCount !== 1) {
                toast.error('Please select exactly one institution as "Highest qualification".');
                return;
            }

            let imageUrl = uploadedPreviews.profileUrl;
            let nricdocUrl = uploadedPreviews.nricdoc;
            let educationaldocUrl = uploadedPreviews.educationdoc;
            let passportdocUrl = uploadedPreviews.passportdoc;

            // Cloudinary upload function
            const uploadToCloudinary = async (file, path) => {
                const timestamp = Date.now();
                const fileExtension = file.name.split('.').pop();
                const fileNameWithTimestamp = `${timestamp}.${fileExtension}`;

                const formDataWithImage = new FormData();
                formDataWithImage.append('file', file, fileNameWithTimestamp);
                formDataWithImage.append('upload_preset', CLOUDINARY_UPLOAD);
                formDataWithImage.append('public_id', `LMS/Student/${path}/${fileNameWithTimestamp}`);

                const imageResponse = await fetch(CLOUDINARY_URL, {
                    method: 'POST',
                    body: formDataWithImage,
                });

                const imageData = await imageResponse.json();
                if (!imageResponse.ok || !imageData.secure_url) {
                    throw new Error(`Failed to upload file: ${file.name}`);
                }
                return imageData.secure_url;
            };

            // Upload files if selected
            if (selectedFile) imageUrl = await uploadToCloudinary(selectedFile, 'Profile');
            if (nricdoc) nricdocUrl = await uploadToCloudinary(nricdoc, 'NRIC');
            if (educationdoc) educationaldocUrl = await uploadToCloudinary(educationdoc, 'EducationalDocs');
            if (passportdoc) passportdocUrl = await uploadToCloudinary(passportdoc, 'PassportDocs');

            // Prepare updated student object
            const updatedStudent = {
                ...editFormData,
                profileUrl: imageUrl,
                nricdoc: nricdocUrl,
                educationdoc: educationaldocUrl,
                passportdoc: passportdocUrl,
                startModulus: editFormData?.scheduleDate?.[0]?.startModulus || editFormData.startModulus,
            };

            // API request
            const response = await axios.put(
                `/registrationadvances/${editFormData.id}`,
                updatedStudent
            );

            if (response.status === 200) {
                toast.success('Student updated successfully');
                onAction();
            } else {
                throw new Error('Failed to update student.');
            }
        } catch (error) {
            console.error('Error updating student:', error);
            toast.error('An error occurred while updating the student. Please try again.');
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];
        const fileUrl = URL.createObjectURL(file);

        switch (name) {
            case 'profile':
                setSelectedFile(file);
                setUploadedPreviews((prev) => ({ ...prev, profileUrl: fileUrl }));
                break;
            case 'nric':
                setNricdoc(file);
                setUploadedPreviews((prev) => ({ ...prev, nricdoc: fileUrl }));
                break;
            case 'educational':
                setEducationaldoc(file);
                setUploadedPreviews((prev) => ({ ...prev, educationdoc: fileUrl }));
                break;
            case 'passport':
                setPassportdoc(file);
                setUploadedPreviews((prev) => ({ ...prev, passportdoc: fileUrl }));
                break;
            default:
                break;
        }
    };

    const handleInstitutionChange = (index, e) => {
        const { name, value } = e.target;
        const updatedInstitutions = editFormData.institutionDetails.map((institution, i) => {
            if (i === index) {
                const updatedInstitution = { ...institution, [name]: value };

                const fromYear = name === 'fromYear' ? value : updatedInstitution.fromYear;
                const toYear = name === 'toYear' ? value : updatedInstitution.toYear;

                // Only validate if both fields are filled with 4-digit years
                if (
                    fromYear?.length === 4 &&
                    toYear?.length === 4 &&
                    !isNaN(Number(fromYear)) &&
                    !isNaN(Number(toYear)) &&
                    Number(toYear) < Number(fromYear)
                ) {
                    toast.error('To Year must be greater than or equal to From Year');
                }

                return updatedInstitution;
            }
            return institution;
        });
        setEditFormData({ ...editFormData, institutionDetails: updatedInstitutions });
    };

    const handleAddEducation = () => {
        setEditFormData({
            ...editFormData,
            institutionDetails: [
                ...editFormData.institutionDetails,
                { institution: '', fromYear: '', toYear: '', qualificationsAchieved: '', highest: false, language: '' },
            ],
        });
    };

    const handleRemoveEducation = (index) => {
        const newInstitutionDetails = editFormData.institutionDetails.filter((_, i) => i !== index);
        setEditFormData({ ...editFormData, institutionDetails: newInstitutionDetails });
    };


    const handleWorkExperienceChange = (index, e) => {
        const { name, value } = e.target;

        // Clone and update the current experience
        const updatedExperiences = [...editFormData.workExpirences];
        const current = updatedExperiences[index];
        const updatedField = { ...current, [name]: value };
        updatedExperiences[index] = updatedField;

        // Parse years
        const fromYear = parseInt(updatedField.fromYear);
        const toYear = parseInt(updatedField.toYear);

        setEditFormData({
            ...editFormData,
            workExpirences: updatedExperiences,
        });

        if (name === "fromYear" || name === "toYear") {
            if (
                updatedField.fromYear?.length === 4 &&
                updatedField.toYear?.length === 4 &&
                !isNaN(fromYear) &&
                !isNaN(toYear) &&
                toYear < fromYear
            ) {
                toast.error("To Year must be ≥ From Year");
            }
        }
    };

    const handleAddWorkExperience = () => {
        setEditFormData((prevState) => ({
            ...prevState,
            workExpirences: [
                ...prevState.workExpirences,
                { name: '', position: '', fromYear: '', toYear: '', country: '', natureOfPosition: '' }
            ]
        }));
    };

    const handleRemoveWorkExperience = (index) => {
        const newWorkExperiences = editFormData.workExpirences.filter((_, i) => i !== index);
        setEditFormData({
            ...editFormData,
            workExpirences: newWorkExperiences
        });
        if (newWorkExperiences.length === 0) {
            //   setShowEmploymentFields(false); // Hide employment fields if no experience entries
        }
    };


    const moduleDetailsMap = {};
    editFormData.batch?.moduleDetails.forEach((module) => {
        moduleDetailsMap[module.id] = module.moduleName;
    });

    const dayMapping = {
        'Sunday': 0,
        'Monday': 1,
        'Tuesday': 2,
        'Wednesday': 3,
        'Thursday': 4,
        'Friday': 5,
        'Saturday': 6
    };

    //for enrollment date edit
    // const handleDateChange = (event) => {

    //     const selectedBatch = batches.find((batch) => batch.id === selectedBatchesData.id);
    //     // setSelectedBatchesData(selectedBatch);
    //     console.log(selectedBatch?.status);

    //     const { value } = event.target;
    //     const newDate = dayjs(value);
    //     const oldDate = dayjs(editFormData.enrolledDate);

    //     const intakeStartDate = selectedBatch?.intakeStartDate ? dayjs(selectedBatch.intakeStartDate) : null;
    //     const isDatePassed = intakeStartDate && newDate.isAfter(intakeStartDate);


    //     if (selectedBatch?.status && newDate.isBefore(oldDate, 'day') && intakeStartDate) {
    //         // toast.error("Enrollment date cannot be before today.");
    //         alert("Enrollment date cannot be before today.")
    //         return;
    //     } else if (selectedBatch?.status && isDatePassed) {
    //         alert("Batch is not started yet.");
    //         return;
    //     } else if (selectedBatch?.status && !isDatePassed) {
    //         console.log("Batch is active. Using current module:", selectedBatch?.currentModule);
    //         setEditFormData((prev) => ({
    //             ...prev,
    //             enrolledDate: value,
    //             startModulus: selectedBatch.currentModule,
    //             offerDate: value
    //         }));
    //         return;
    //     }


    //     const firstDay = editFormData.batch.days[0];
    //     const dayIndex = dayMapping[firstDay.day];

    //     // Helper to find the first Sunday of the month
    //     const getFirstSunday = (date) => {
    //         let firstSunday = date.startOf('month');
    //         while (firstSunday.day() !== dayIndex) { // 0 is Sunday in Day.js
    //             firstSunday = firstSunday.add(1, 'day');
    //         }
    //         return firstSunday;
    //     };

    //     // Determine the effective month (current or next based on first Sunday)
    //     const getEffectiveMonth = (date) => {
    //         const firstSunday = getFirstSunday(date);
    //         return date.isAfter(firstSunday)
    //             ? date.add(1, 'month').startOf('month')
    //             : date.startOf('month');
    //     };

    //     // Calculate effective months for both dates
    //     const oldEffective = getEffectiveMonth(oldDate);
    //     const newEffective = getEffectiveMonth(newDate);

    //     // Month difference between effective months
    //     const deltaMonths = newEffective.diff(oldEffective, 'month');

    //     // Calculate new modulus (1-12)
    //     let newModulus = editFormData.startModulus + deltaMonths;
    //     newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1; // Ensure 1-12

    //     // Update state
    //     setEditFormData((prev) => ({
    //         ...prev,
    //         enrolledDate: value,
    //         startModulus: newModulus,
    //         offerDate: value
    //     }));
    // };

    //if course changes need new startmodulus 
    // const handleDateChangeForCourse = (batch, currentDate) => {
    //     // Get the new date from the event
    //     //    const { value } = event.target;
    //     //    console.log("Selected Enrollment Date:", value);

    //     const newDate = dayjs(currentDate); // Create dayjs object from the new date
    //     const oldDate = dayjs(); // Get the current date

    //     console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
    //     console.log("New Date:", newDate.format('YYYY-MM-DD'));

    //     // Calculate the difference in months between the old and new dates
    //     let monthDifference = newDate.month() - oldDate.month();
    //     if (newDate.year() !== oldDate.year()) {
    //         monthDifference += (newDate.year() - oldDate.year()) * 12;
    //     }
    //     console.log("Month Difference:", monthDifference);

    //     // For advance diploma, the increment is simply the month difference
    //     let increment = monthDifference;
    //     console.log("Advance Diploma Course - Increment:", increment);

    //     // Calculate the new modulus value based on the increment
    //     let newModulus = batch.currentModule + increment;
    //     // Wrap around to keep it between 1 and 12 (instead of 1 and 6)
    //     newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1;
    //     console.log("New Modulus Before Ensuring Range:", newModulus);

    //     const firstDay = batch.days[0]; // Assuming days is in the correct scope
    //     console.log("First Day from Data:", firstDay.day);

    //     const dayIndex = dayMapping[firstDay.day];
    //     // Determine the first occurrence of the specified day of the month
    //     const firstOfMonth = newDate.date(1); // Set to the first of the month
    //     let firstSpecifiedDay = firstOfMonth.day(dayIndex); // Find the first occurrence

    //     // If the first occurrence is in the previous month, move to the next week
    //     if (firstSpecifiedDay.isBefore(firstOfMonth)) {
    //         firstSpecifiedDay = firstSpecifiedDay.add(1, 'week');
    //     }

    //     console.log("First Specified Day of the Month:", firstSpecifiedDay.format('YYYY-MM-DD'));

    //     // Adjust modulus: if the enrollment date is after the first specified day,
    //     // add 1 to the new modulus.
    //     if (newDate.isAfter(firstSpecifiedDay)) {
    //         newModulus += 1;
    //         console.log("Adjusting Modulus by adding 1.");
    //     }

    //     // Ensure modulus value stays within the 1-12 range after adjustments
    //     newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1;


    //     console.log("newModulus", newModulus)
    //     return newModulus;

    // };


    const closeEditModal = () => {
        setEditModalOpen(false);
    };

    useEffect(() => {
        const fetchBatches = async () => {
            try {
                const response = await axios.get("batch-summary"); // API endpoint to get batches
                setBatches(response.data);
            } catch (error) {
                console.error("Error fetching batches:", error);
            }
        };

        fetchBatches();
    }, []);


    const fetchintake = async (id) => {
        try {
            console.log("Fetching intake details for batch:", id);
            const response1 = await axios.get(`/intake-details/batch/${id}`); // API endpoint to get batches
            // setIntake(response1.data);
            setIntakeOptions(response1.data)

        } catch (error) {
            console.error("Error fetching batches:", error);
        }
    };

    const handleManualScheduleStart = (firstModulus, firstDate) => {
        if (!firstDate) {
            toast.warning("Please select Start Date first.");
            return;
        }

        const totalModules = selectedBatchesData?.moduleDetails?.length || 0;
        const moduli = getCycledModuli(parseInt(firstModulus));
        let startDate = firstDate;
        const modules = [];

        for (let i = 0; i < totalModules; i++) {
            const { endDate, nextStartDate } = getNextWeekDates(startDate);
            modules.push({
                startModulus: moduli[i],
                startDate,
                endDate,
            });
            startDate = nextStartDate;
        }

        setEditFormData((prevData) => ({
            ...prevData,
            scheduleDate: modules,
        }));

        console.log("Updated scheduleDate:", modules);
    };



    // Cycle modulus
    const getCycledModuli = (start, count = moduleCount) =>
        Array.from({ length: count }, (_, i) => ((start + i - 1) % moduleCount) + 1);

    // Get next date on same weekday
    const getNextWeekDates = (startDateStr) => {
        const start = new Date(startDateStr);
        const weekDates = [];

        for (let i = 0; i < 4; i++) {
            const nextDate = new Date(start);
            nextDate.setDate(start.getDate() + i * 7);
            weekDates.push(nextDate);
        }

        return {
            endDate: weekDates[3].toISOString().split('T')[0],
            nextStartDate: (() => {
                const d = new Date(weekDates[3]);
                d.setDate(d.getDate() + 7);
                return d.toISOString().split('T')[0];
            })(),
        };
    };


    const handleIntakeChange = (e) => {
        const selectedIntakeId = e.target.value;

        // Always set intakeId state
        setIntakeId(selectedIntakeId);

        // Handle default option ("-- Select Intake --")
        if (selectedIntakeId === "") {
            setEditFormData((prevData) => ({
                ...prevData,
                scheduleDate: [],
            }));
            return;
        }

        // Find the selected intake from the options
        const selectedIntake = intakeOptions.find(
            (intake) => String(intake.intakeId) === selectedIntakeId
        );

        if (selectedIntake) {
            const scheduleData = selectedIntake.scheduleDateDetails.map((schedule) => ({
                startModulus: schedule.startModulus,
                startDate: schedule.startDate,
                endDate: schedule.endDate,
            }));

            setEditFormData((prevData) => ({
                ...prevData,
                scheduleDate: scheduleData,
            }));

            console.log("Selected Intake:", scheduleData);
        }
    };




    const handleModuleChange = (index, field, value) => {
        const updatedModules = [...editFormData.scheduleDate];
        updatedModules[index][field] = field === 'startModulus' ? parseInt(value) : value;
        setEditFormData({ ...editFormData, scheduleDate: updatedModules });
    };

    const handleEmergencyChange = (index, field, value) => {
        const updatedContacts = [...editFormData.emergencyContacts];
        updatedContacts[index][field] = value;
        setEditFormData({ ...editFormData, emergencyContacts: updatedContacts });
    };

    const handleAddEmergency = () => {
        setEditFormData({
            ...editFormData,
            emergencyContacts: [
                ...editFormData.emergencyContacts,
                { name: '', number: '', relationship: '', othersRelationship: '' },
            ],
        });
    };

    const handleRemoveEmergency = (index) => {
        const updatedContacts = [...editFormData.emergencyContacts];
        updatedContacts.splice(index, 1);
        setEditFormData({ ...editFormData, emergencyContacts: updatedContacts });
    };


    const handleProjectChange = (field, value) => {
        setEditFormData((prev) => ({
            ...prev,
            projectSchedule: {
                ...prev.projectSchedule,
                [field]: value,
            },
        }));
    };

    useEffect(() => {
        fetchintake(editForm.batch?.id);
    }, []);

    return (
        <Container component="main" maxWidth="md">
            {/* <Paper style={{ borderRadius: '8px', maxWidth: '1400px', margin: '62px' }}> */}
            <form onSubmit={handleSaveEdit}>
                <Grid container spacing={3}>
                    {/* Section 1: Personal Information */}
                    <Grid item xs={12}>
                        <Paper sx={{ p: 3, mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                                Personal Information
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Full Name*"
                                        name="name"
                                        value={editFormData.name}
                                        onChange={handleChange}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Email*"
                                        name="email"
                                        value={editFormData.email}
                                        onChange={handleNricEmailChange}
                                        fullWidth
                                        variant="outlined"
                                        error={!!errors.email}
                                        helperText={errors.email}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="NRIC*"
                                        name="nric"
                                        value={editFormData.nric}
                                        onChange={handleNricEmailChange}
                                        inputProps={{ maxLength: 9 }}
                                        fullWidth
                                        variant="outlined"
                                        error={!!errors.nric}
                                        helperText={errors.nric}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Passport*"
                                        name="passport"
                                        value={editFormData.passport}
                                        onChange={handleChange}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        select
                                        label="Marital Status*"
                                        name="maritalStatus"
                                        value={editFormData.maritalStatus}
                                        onChange={handleChange}
                                        fullWidth
                                        variant="outlined"
                                    >
                                        {statusOptions.map((option) => (
                                            <MenuItem key={option} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>


                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Passport Expiry Date*"
                                        name="passportExpiryDate"
                                        value={editFormData.passportExpiryDate}
                                        onChange={handleChange}
                                        fullWidth
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel>Course*</InputLabel>
                                        <Select
                                            name="course"
                                            value={editFormData.course}
                                            onChange={handleChange}
                                            label="Course*"
                                        >
                                            <MenuItem value=""><em>Select Course...</em></MenuItem>
                                            {batches.map((batch) => (
                                                <MenuItem key={batch.id} value={batch.course}>
                                                    {batch.course}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        type="number"
                                        label="Course Fee*"
                                        name="courseFee"
                                        value={editFormData.courseFee}
                                        onChange={handleChange}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel>Gender*</InputLabel>
                                        <Select
                                            name="gender"
                                            value={editFormData.gender}
                                            onChange={handleChange}
                                            label="Gender*"
                                        >
                                            <MenuItem value="">Select Gender</MenuItem>
                                            <MenuItem value="Male">Male</MenuItem>
                                            <MenuItem value="Female">Female</MenuItem>
                                            <MenuItem value="Other">Other</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        type="date"
                                        label="Date of Birth*"
                                        name="dob"
                                        value={editFormData.dob}
                                        onChange={handleChange}
                                        fullWidth
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                {/* <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Password*"
                                        name="password"
                                        type={showPassword ? 'text' : 'password'} // 👈 Toggle text/password
                                        value={editFormData.password}
                                        onChange={handleChange}
                                        fullWidth
                                        variant="outlined"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => setShowPassword((prev) => !prev)}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid> */}

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Religion*"
                                        name="religion"
                                        value={editFormData.religion}
                                        onChange={handleChange}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Citizenship*"
                                        name="citizenship"
                                        value={editFormData.citizenship}
                                        onChange={handleChange}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    {/* Section 2: Contact Information */}
                    <Grid item xs={12}>
                        <Paper sx={{ p: 3, mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                                Contact Information
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        type="number"
                                        label="Hand Phone*"
                                        name="phone"
                                        value={editFormData.phone}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 10 }}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        type="number"
                                        label="Office Phone*"
                                        name="officephone"
                                        value={editFormData.officephone}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 10 }}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Home Address*"
                                        name="address"
                                        value={editFormData.address}
                                        onChange={handleChange}
                                        fullWidth
                                        variant="outlined"
                                        multiline
                                        rows={3}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Singapore Address*"
                                        name="currentAddress"
                                        value={editFormData.currentAddress}
                                        onChange={handleChange}
                                        fullWidth
                                        variant="outlined"
                                        multiline
                                        rows={3}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Postal Code*"
                                        name="postalcode"
                                        value={editFormData.postalcode}
                                        onChange={(e) => {
                                            if (/^\d{0,6}$/.test(e.target.value)) {
                                                handleChange(e);
                                            }
                                        }}
                                        inputProps={{ maxLength: 6 }}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    {/* Section 3: Family Information */}
                    {/* <Grid item xs={12}>
                            <Paper  sx={{ p: 3, mb: 3 }}>
                                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                                    Family Information
                                </Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            label="Father Name*"
                                            name="fatherName"
                                            value={editFormData.fatherName}
                                            onChange={handleChange}
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            type="number"
                                            label="Father PhoneNo*"
                                            name="fatherPhoneNo"
                                            value={editFormData.fatherPhoneNo}
                                            onChange={handleChange}
                                            inputProps={{ maxLength: 10 }}
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            label="Brother Name*"
                                            name="brotherName"
                                            value={editFormData.brotherName}
                                            onChange={handleChange}
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            type="number"
                                            label="Brother PhoneNo*"
                                            name="brotherPhoneNo"
                                            value={editFormData.brotherPhoneNo}
                                            onChange={handleChange}
                                            inputProps={{ maxLength: 10 }}
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid> */}

                    {/* Section 4: Education History */}
                    <Grid item xs={12}>
                        <Paper sx={{ p: 3, mb: 3 }}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    Education History
                                </Typography>
                                <Button
                                    variant="contained"
                                    startIcon={<AddIcon />}
                                    onClick={handleAddEducation}
                                >
                                    Add Education
                                </Button>
                            </Box>

                            {(editFormData.institutionDetails || []).map((institution, index) => (
                                <Card key={index} sx={{ p: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                        <input
                                            type="checkbox"
                                            id={`highest-${index}`}
                                            checked={!!institution.highest}
                                            onChange={(e) => {
                                                const updatedInstitutions = editFormData.institutionDetails.map((inst, i) => ({
                                                    ...inst,
                                                    highest: i === index ? e.target.checked : false,
                                                }));
                                                setEditFormData({ ...editFormData, institutionDetails: updatedInstitutions });
                                            }}
                                            style={{ marginRight: 6 }}
                                        />
                                        <label htmlFor={`highest-${index}`} style={{ fontSize: 13 }}>
                                            Highest
                                        </label>
                                    </Box>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Institution Name"
                                                name="institution"
                                                value={institution.institution || ''}
                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Degree"
                                                name="qualificationsAchieved"
                                                value={institution.qualificationsAchieved || ''}
                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                type="number"
                                                label="From Year"
                                                name="fromYear"
                                                value={institution.fromYear || ''}
                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                fullWidth
                                                variant="outlined"
                                                inputProps={{ min: 1900, max: new Date().getFullYear() }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                type="number"
                                                label="To Year"
                                                name="toYear"
                                                value={institution.toYear || ''}
                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                fullWidth
                                                variant="outlined"
                                                inputProps={{ min: 1900, max: new Date().getFullYear() }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="Country"
                                                name="country"
                                                value={institution.country || ''}
                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="Language of Instruction"
                                                name="language"
                                                value={institution.language || ''}
                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                                                <Button
                                                    variant="outlined"
                                                    color="error"
                                                    startIcon={<DeleteIcon />}
                                                    onClick={() => handleRemoveEducation(index)}
                                                >
                                                    Remove
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Card>
                            ))}

                        </Paper>
                    </Grid>

                    {/* Section 5: Work Experience */}
                    <Grid item xs={12}>
                        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    Work Experience
                                </Typography>
                                <Button
                                    variant="contained"
                                    startIcon={<AddIcon />}
                                    onClick={handleAddWorkExperience}
                                >
                                    Add Employment
                                </Button>
                            </Box>

                            {editFormData.workExpirences?.map((experience, index) => (
                                <Card key={index} sx={{ p: 2, mb: 2 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Company Name"
                                                name="name"
                                                value={experience.name}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Position"
                                                name="position"
                                                value={experience.position}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="Country"
                                                name="country"
                                                value={experience.country}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                type="number"
                                                label="From Year"
                                                name="fromYear"
                                                value={experience.fromYear}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                type="number"
                                                label="To Year"
                                                name="toYear"
                                                value={experience.toYear}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="Nature of Duties"
                                                name="natureOfPosition"
                                                value={experience.natureOfPosition}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                startIcon={<DeleteIcon />}
                                                onClick={() => handleRemoveWorkExperience(index)}
                                                sx={{ float: 'right' }}
                                            >
                                                Remove
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Card>
                            ))}
                        </Paper>
                    </Grid>

                    {/* Section 6: Emergency Contacts */}
                    <Grid item xs={12}>
                        <Paper sx={{ p: 3, mb: 3 }}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    Emergency Contacts
                                </Typography>
                                <Button
                                    variant="contained"
                                    startIcon={<AddIcon />}
                                    onClick={handleAddEmergency}
                                >
                                    Add Emergency Contact
                                </Button>
                            </Box>
                            {editFormData.emergencyContacts?.map((contact, index) => (
                                <Card key={index} sx={{ p: 2, mb: 2 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel>Relationship</InputLabel>
                                                <Select
                                                    value={contact.relationship}
                                                    onChange={(e) => handleEmergencyChange(index, 'relationship', e.target.value)}
                                                    label="Relationship"
                                                >
                                                    <MenuItem value="">-- Select Relationship --</MenuItem>
                                                    <MenuItem value="Father">Father</MenuItem>
                                                    <MenuItem value="Mother">Mother</MenuItem>
                                                    <MenuItem value="Brother">Brother</MenuItem>
                                                    <MenuItem value="Sister">Sister</MenuItem>
                                                    <MenuItem value="Others">Others</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        {contact.relationship === 'Others' && (
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    label="Relationship with Applicant"
                                                    value={contact.othersRelationship}
                                                    onChange={(e) => handleEmergencyChange(index, 'othersRelationship', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                />
                                            </Grid>
                                        )}

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Name"
                                                value={contact.name}
                                                onChange={(e) => handleEmergencyChange(index, 'name', e.target.value)}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                type="tel"
                                                label="Contact No"
                                                value={contact.number}
                                                onChange={(e) => handleEmergencyChange(index, 'number', e.target.value)}
                                                inputProps={{ maxLength: 10 }}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                startIcon={<DeleteIcon />}
                                                onClick={() => handleRemoveEmergency(index)}
                                                sx={{ float: 'right' }}
                                            >
                                                Remove
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Card>
                            ))}


                        </Paper>
                    </Grid>

                    {/* Section 7: Documents */}
                    <Grid item xs={12}>
                        <Paper sx={{ p: 3, mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                                Documents
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <Card sx={{ p: 2 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                            Upload Photo*
                                        </Typography>
                                        <input
                                            type="file"
                                            name="profile"
                                            accept="image/png, image/jpeg, image/jpg"
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }}
                                            id="profile-upload"
                                        />
                                        <label htmlFor="profile-upload">
                                            <Button variant="outlined" component="span" fullWidth>
                                                Choose File
                                            </Button>
                                        </label>
                                        {uploadedPreviews.profileUrl && (
                                            <Box sx={{ mt: 2 }}>
                                                <Typography variant="body2">Preview:</Typography>
                                                <img
                                                    src={uploadedPreviews.profileUrl}
                                                    alt="Profile Preview"
                                                    style={{ maxWidth: '100%', maxHeight: '150px', marginTop: '8px' }}
                                                />
                                            </Box>
                                        )}
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Card sx={{ p: 2 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                            NRIC Document*
                                        </Typography>
                                        <input
                                            type="file"
                                            name="nric"
                                            accept="application/pdf"
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }}
                                            id="nric-upload"
                                        />
                                        <label htmlFor="nric-upload">
                                            <Button variant="outlined" component="span" fullWidth>
                                                Choose File
                                            </Button>
                                        </label>
                                        {uploadedPreviews.nricdoc && (
                                            <Box sx={{ mt: 2 }}>
                                                <Typography variant="body2">Preview:</Typography>
                                                <img
                                                    src={uploadedPreviews.nricdoc}
                                                    alt="NRIC Document Preview"
                                                    style={{ maxWidth: '100%', maxHeight: '150px', marginTop: '8px' }}
                                                />
                                            </Box>
                                        )}
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Card sx={{ p: 2 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                            Educational Document*
                                        </Typography>
                                        <input
                                            type="file"
                                            name="educational"
                                            accept="application/pdf"
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }}
                                            id="education-upload"
                                        />
                                        <label htmlFor="education-upload">
                                            <Button variant="outlined" component="span" fullWidth>
                                                Choose File
                                            </Button>
                                        </label>
                                        {uploadedPreviews.educationdoc && (
                                            <Box sx={{ mt: 2 }}>
                                                <Typography variant="body2">Preview:</Typography>
                                                <img
                                                    src={uploadedPreviews.educationdoc}
                                                    alt="Education Document Preview"
                                                    style={{ maxWidth: '100%', maxHeight: '150px', marginTop: '8px' }}
                                                />
                                            </Box>
                                        )}
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Card sx={{ p: 2 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                            Passport Document*
                                        </Typography>
                                        <input
                                            type="file"
                                            name="passport"
                                            accept="application/pdf"
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }}
                                            id="passport-upload"
                                        />
                                        <label htmlFor="passport-upload">
                                            <Button variant="outlined" component="span" fullWidth>
                                                Choose File
                                            </Button>
                                        </label>
                                        {uploadedPreviews.passportdoc && (
                                            <Box sx={{ mt: 2 }}>
                                                <Typography variant="body2">Preview:</Typography>
                                                <img
                                                    src={uploadedPreviews.passportdoc}
                                                    alt="Passport Document Preview"
                                                    style={{ maxWidth: '100%', maxHeight: '150px', marginTop: '8px' }}
                                                />
                                            </Box>
                                        )}
                                    </Card>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    {/* Section 8: Module Schedule */}
                    {editFormData.scheduleDate?.length > 0 && (
                        <Grid item xs={12}>
                            <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                                    Module Schedule
                                </Typography>

                                <Grid container spacing={2} sx={{ mb: 3 }}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            type="date"
                                            label="Start Date"
                                            value={editFormData.scheduleDate[0]?.startDate || ''}
                                            onChange={(e) =>
                                                handleManualScheduleStart(
                                                    editFormData.scheduleDate[0]?.startModulus || '',
                                                    e.target.value
                                                )
                                            }
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel>Start Module</InputLabel>
                                            <Select
                                                value={editFormData.scheduleDate[0]?.startModulus || ''}
                                                onChange={(e) =>
                                                    handleManualScheduleStart(
                                                        e.target.value,
                                                        editFormData.scheduleDate[0]?.startDate || ''
                                                    )
                                                }
                                                label="Start Module"
                                            >
                                                <MenuItem value="">Select Module</MenuItem>
                                                {selectedBatchesData?.moduleDetails?.map((module) => (
                                                    <MenuItem key={module.id} value={module.id}>
                                                        {module?.moduleName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={2}>
                                    {editFormData.scheduleDate.map((module, index) => (
                                        <Grid item xs={12} md={6} key={index}>
                                            <Card sx={{ p: 2 }}>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                                    Module {index + 1}
                                                </Typography>

                                                <TextField
                                                    label="Module Name"
                                                    value={
                                                        selectedBatchesData?.moduleDetails?.find(
                                                            (m) => m.id === module.startModulus
                                                        )?.moduleName || module.startModulus
                                                    }
                                                    fullWidth
                                                    variant="outlined"
                                                    sx={{ mb: 2 }}
                                                    InputProps={{ readOnly: true }}
                                                />

                                                <TextField
                                                    type="date"
                                                    label="Start Date"
                                                    value={module.startDate}
                                                    onChange={(e) =>
                                                        handleModuleChange(index, "startDate", e.target.value)
                                                    }
                                                    fullWidth
                                                    variant="outlined"
                                                    sx={{ mb: 2 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                                <TextField
                                                    type="date"
                                                    label="End Date"
                                                    value={module.endDate}
                                                    onChange={(e) =>
                                                        handleModuleChange(index, "endDate", e.target.value)
                                                    }
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Paper>
                        </Grid>
                    )}

                    {/* Section 9: Project Details */}
                    <Grid item xs={12}>
                        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                                Project Details
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        label="Project Code*"
                                        name="projectCode"
                                        value={editFormData.projectSchedule?.projectCode || ''}
                                        onChange={(e) => handleProjectChange('projectCode', e.target.value)}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        type="date"
                                        label="Start Date*"
                                        name="projectstartDate"
                                        value={editFormData.projectSchedule?.startDate || ''}
                                        onChange={(e) => handleProjectChange('startDate', e.target.value)}
                                        fullWidth
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        type="date"
                                        label="End Date*"
                                        name="projectendDate"
                                        value={editFormData.projectSchedule?.endDate || ''}
                                        onChange={(e) => handleProjectChange('endDate', e.target.value)}
                                        fullWidth
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    {/* Section 10: Intake Selection */}
                    <Grid item xs={12}>
                        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                            <Grid container spacing={2}>

                                {/* Intake Selection */}
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h6" sx={{ fontWeight: 500, mb: 1 }}>
                                        Intake Selection
                                    </Typography>

                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel>Select Intake</InputLabel>
                                        <Select
                                            value={intakeId || editFormData?.preIntake}
                                            onChange={handleIntakeChange}
                                            label="Select Intake"
                                        >
                                            <MenuItem value="">-- Select Intake --</MenuItem>
                                            {intakeOptions.map((intake) => (
                                                <MenuItem key={intake.id} value={intake.intakeId}>
                                                    {intake.intakeId}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Sign Date */}
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h6" sx={{ fontWeight: 500, mb: 1, }}>
                                        Sign Date
                                    </Typography>

                                    <TextField
                                        label="Sign Date"
                                        type="date"
                                        name="signDate"
                                        value={editFormData.signDate}
                                        onChange={handleChange}
                                        fullWidth
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>

                            </Grid>
                        </Paper>
                    </Grid>


                    {/* Submit Button */}
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                size="large"
                                sx={{ minWidth: 150 }}
                            >
                                Update
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </form>
            {/* </Paper> */}

            <ToastContainer />
        </Container >
    );
};

export default ViewDetailsModal;
